import { Box } from "@vapor/react-material";

const HeaderBar = () => (
    <Box
        sx={{
            p: 2,
            boxShadow: "0px 2px 8px 0px rgba(21, 41, 53, 0.32)",
            backgroundColor: "rgb(21, 41, 53)",
            color: "rgb(255,255,255)",
            fontSize: "16px",
            fontFamily: "Roboto",
            fontWeight: "bold",
            height: "4rem",
            display: "flex",
            alignItems: "center",
        }}
    >
        TeamSystem
    </Box>
);

export default HeaderBar;
